export var DEPLOY_DATE = new Date('2026-07-20T22:34:09+0000');
